// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/core/svc_report.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { Empty, proto3 } from "@bufbuild/protobuf";
import { Report, ReportExtendedConclusion, ReportPrintSettings } from "../../model/dto_report_pb.js";
import { Patient } from "../../model/dto_patient_pb.js";
import { Organization } from "../../model/dto_organization_pb.js";
import { Study } from "../../model/dto_study_pb.js";
import { Tooth, ToothFullHeadMPR, ToothFullHeadMPRSliceEditorState, ToothFullHeadMPRSliceGeometry, ToothFullHeadMPRSliceSeries, ToothFullHeadMPRSliceView, ToothMPRSliceOptions } from "../../model/dto_report_tooth_pb.js";
import { Condition } from "../../model/dto_report_condition_pb.js";
import { ToothLandmark } from "../../model/dto_report_landmark_pb.js";
import { Asset, AssetType } from "../../model/dto_asset_pb.js";
import { User } from "../../model/dto_user_pb.js";
import { ConditionCode } from "../../model/dto_report_condition_codes_pb.js";
import { ToothNumeration } from "../../model/dto_report_common_pb.js";
import { ReportRequest } from "../../model/dto_report_request_pb.js";
import { Attribute } from "../../model/dto_base_pb.js";
import { MedicalImageViewOptions, MedicalImageViewOptions_Legacy } from "../../model/dto_common_image_view_options_pb.js";
import { Annotation, Annotations } from "../../model/dto_common_image_annotations_pb.js";
import { ClosedPolygon } from "../../model/dto_common_geometry_pb.js";

/**
 * @generated from message com.diagnocat.core.ReportDataStreamReq
 */
export const ReportDataStreamReq = proto3.makeMessageType(
  "com.diagnocat.core.ReportDataStreamReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "SkipStudies", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "SkipTeeth", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "SkipConditions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "SkipTeethLandmarks", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "SkipUsers", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "SkipAssets", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.ReportDataStreamResp
 */
export const ReportDataStreamResp = proto3.makeMessageType(
  "com.diagnocat.core.ReportDataStreamResp",
  () => [
    { no: 1, name: "HistoricalReport", kind: "message", T: Report, oneof: "Update" },
    { no: 2, name: "HistoricalPatient", kind: "message", T: Patient, oneof: "Update" },
    { no: 15, name: "HistoricalOrganization", kind: "message", T: Organization, oneof: "Update" },
    { no: 3, name: "HistoricalStudy", kind: "message", T: Study, oneof: "Update" },
    { no: 4, name: "EndOfHistoricalStudies", kind: "message", T: Empty, oneof: "Update" },
    { no: 5, name: "HistoricalTooth", kind: "message", T: Tooth, oneof: "Update" },
    { no: 6, name: "EndOfHistoricalTeeth", kind: "message", T: Empty, oneof: "Update" },
    { no: 7, name: "HistoricalCondition", kind: "message", T: Condition, oneof: "Update" },
    { no: 8, name: "EndOfHistoricalConditions", kind: "message", T: Empty, oneof: "Update" },
    { no: 9, name: "HistoricalToothLandmark", kind: "message", T: ToothLandmark, oneof: "Update" },
    { no: 10, name: "EndOfHistoricalTeethLandmarks", kind: "message", T: Empty, oneof: "Update" },
    { no: 11, name: "HistoricalAsset", kind: "message", T: Asset, oneof: "Update" },
    { no: 61, name: "EndOfHistoricalAssetsType", kind: "enum", T: proto3.getEnumType(AssetType), oneof: "Update" },
    { no: 12, name: "EndOfHistoricalAssets", kind: "message", T: Empty, oneof: "Update" },
    { no: 13, name: "HistoricalUser", kind: "message", T: User, oneof: "Update" },
    { no: 14, name: "EndOfHistoricalUsers", kind: "message", T: Empty, oneof: "Update" },
    { no: 16, name: "HistoricalCurrentUser", kind: "message", T: User, oneof: "Update" },
    { no: 17, name: "HistoricalToothFullHeadMPR", kind: "message", T: ToothFullHeadMPR, oneof: "Update" },
    { no: 18, name: "EndOfHistoricalToothFullHeadMPR", kind: "message", T: Empty, oneof: "Update" },
    { no: 52, name: "ConditionCodesMap", kind: "message", T: ReportDataStreamResp_AllowedConditionCodesMap, oneof: "Update" },
  ],
);

/**
 * @generated from message com.diagnocat.core.ReportDataStreamResp.TeethNumerationsByConditionCode
 */
export const ReportDataStreamResp_TeethNumerationsByConditionCode = proto3.makeMessageType(
  "com.diagnocat.core.ReportDataStreamResp.TeethNumerationsByConditionCode",
  () => [
    { no: 1, name: "Code", kind: "enum", T: proto3.getEnumType(ConditionCode) },
    { no: 2, name: "TeethNumerations", kind: "message", T: ToothNumeration, repeated: true },
  ],
  {localName: "ReportDataStreamResp_TeethNumerationsByConditionCode"},
);

/**
 * Condition codes allowed for a tooth with the given type and position.
 *
 * @generated from message com.diagnocat.core.ReportDataStreamResp.AllowedConditionCodes
 */
export const ReportDataStreamResp_AllowedConditionCodes = proto3.makeMessageType(
  "com.diagnocat.core.ReportDataStreamResp.AllowedConditionCodes",
  () => [
    { no: 1, name: "ToothType", kind: "enum", T: proto3.getEnumType(ConditionCode) },
    { no: 2, name: "ToothPosition", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "ConditionCodes", kind: "enum", T: proto3.getEnumType(ConditionCode), repeated: true },
  ],
  {localName: "ReportDataStreamResp_AllowedConditionCodes"},
);

/**
 * Contains an entry for every tooth type and every position from 1 to 8.
 *
 * @generated from message com.diagnocat.core.ReportDataStreamResp.AllowedConditionCodesMap
 */
export const ReportDataStreamResp_AllowedConditionCodesMap = proto3.makeMessageType(
  "com.diagnocat.core.ReportDataStreamResp.AllowedConditionCodesMap",
  () => [
    { no: 1, name: "Items", kind: "message", T: ReportDataStreamResp_AllowedConditionCodes, repeated: true },
  ],
  {localName: "ReportDataStreamResp_AllowedConditionCodesMap"},
);

/**
 * @generated from message com.diagnocat.core.RequestReportReq
 */
export const RequestReportReq = proto3.makeMessageType(
  "com.diagnocat.core.RequestReportReq",
  () => [
    { no: 1, name: "Request", kind: "message", T: ReportRequest },
    { no: 2, name: "OrderedBy", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "ToRespectAllowCoinsSettings", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.RequestReportResp
 */
export const RequestReportResp = proto3.makeMessageType(
  "com.diagnocat.core.RequestReportResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.GetReportsByStudyAssetAttributesReq
 */
export const GetReportsByStudyAssetAttributesReq = proto3.makeMessageType(
  "com.diagnocat.core.GetReportsByStudyAssetAttributesReq",
  () => [
    { no: 1, name: "AssetAttributes", kind: "message", T: Attribute, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.GetReportsByStudyAssetAttributesResp
 */
export const GetReportsByStudyAssetAttributesResp = proto3.makeMessageType(
  "com.diagnocat.core.GetReportsByStudyAssetAttributesResp",
  () => [
    { no: 1, name: "Reports", kind: "message", T: Report, repeated: true },
    { no: 2, name: "Studies", kind: "message", T: Study, repeated: true },
    { no: 3, name: "StudyAssets", kind: "message", T: Asset, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.ListReportPanoramasWithConditionsReq
 */
export const ListReportPanoramasWithConditionsReq = proto3.makeMessageType(
  "com.diagnocat.core.ListReportPanoramasWithConditionsReq",
  () => [
    { no: 1, name: "ReportIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.ListReportPanoramasWithConditionsResp
 */
export const ListReportPanoramasWithConditionsResp = proto3.makeMessageType(
  "com.diagnocat.core.ListReportPanoramasWithConditionsResp",
  () => [
    { no: 1, name: "Items", kind: "message", T: ListReportPanoramasWithConditionsResp_ReportPanorama, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.ListReportPanoramasWithConditionsResp.ReportPanorama
 */
export const ListReportPanoramasWithConditionsResp_ReportPanorama = proto3.makeMessageType(
  "com.diagnocat.core.ListReportPanoramasWithConditionsResp.ReportPanorama",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
    { no: 2, name: "Panoramas", kind: "message", T: Asset, repeated: true },
    { no: 3, name: "Conditions", kind: "message", T: Condition, repeated: true },
    { no: 4, name: "Teeth", kind: "message", T: Tooth, repeated: true },
  ],
  {localName: "ListReportPanoramasWithConditionsResp_ReportPanorama"},
);

/**
 * @generated from message com.diagnocat.core.DeleteReportReq
 */
export const DeleteReportReq = proto3.makeMessageType(
  "com.diagnocat.core.DeleteReportReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.DeleteReportResp
 */
export const DeleteReportResp = proto3.makeMessageType(
  "com.diagnocat.core.DeleteReportResp",
  () => [
    { no: 1, name: "DeletedReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DeletedToothIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "DeletedConditionIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "DeletedAssetIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "DeletedTeethLandmarkIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "Patient", kind: "message", T: Patient },
  ],
);

/**
 * @generated from message com.diagnocat.core.RestoreReportReq
 */
export const RestoreReportReq = proto3.makeMessageType(
  "com.diagnocat.core.RestoreReportReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.RestoreReportResp
 */
export const RestoreReportResp = proto3.makeMessageType(
  "com.diagnocat.core.RestoreReportResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.ArchiveReportReq
 */
export const ArchiveReportReq = proto3.makeMessageType(
  "com.diagnocat.core.ArchiveReportReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.ArchiveReportResp
 */
export const ArchiveReportResp = proto3.makeMessageType(
  "com.diagnocat.core.ArchiveReportResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetROIReq
 */
export const SetROIReq = proto3.makeMessageType(
  "com.diagnocat.core.SetROIReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ROIToothIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetROIResp
 */
export const SetROIResp = proto3.makeMessageType(
  "com.diagnocat.core.SetROIResp",
  () => [
    { no: 1, name: "AllReportTeeth", kind: "message", T: Tooth, repeated: true },
    { no: 2, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportConclusionReq
 */
export const SetReportConclusionReq = proto3.makeMessageType(
  "com.diagnocat.core.SetReportConclusionReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "LegacyConclusion", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportConclusionResp
 */
export const SetReportConclusionResp = proto3.makeMessageType(
  "com.diagnocat.core.SetReportConclusionResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportExtendedConclusionReq
 */
export const SetReportExtendedConclusionReq = proto3.makeMessageType(
  "com.diagnocat.core.SetReportExtendedConclusionReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Conclusion", kind: "message", T: ReportExtendedConclusion },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportExtendedConclusionResp
 */
export const SetReportExtendedConclusionResp = proto3.makeMessageType(
  "com.diagnocat.core.SetReportExtendedConclusionResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportSettingsReq
 */
export const SetReportSettingsReq = proto3.makeMessageType(
  "com.diagnocat.core.SetReportSettingsReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "LowProbabilityMode", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 3, name: "ShowProblemAreas", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "ShowPanoramaSplitInsteadOfSingle", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "ShowConditionDetails", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "ShowPerio", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "ShowRestorative", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 8, name: "ShowEndo", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 9, name: "ShowAnatomy", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportSettingsResp
 */
export const SetReportSettingsResp = proto3.makeMessageType(
  "com.diagnocat.core.SetReportSettingsResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
    { no: 2, name: "TeethConditions", kind: "message", T: Condition, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportPrintSettingsReq
 */
export const SetReportPrintSettingsReq = proto3.makeMessageType(
  "com.diagnocat.core.SetReportPrintSettingsReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "PrintSettings", kind: "message", T: ReportPrintSettings },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportPrintSettingsResp
 */
export const SetReportPrintSettingsResp = proto3.makeMessageType(
  "com.diagnocat.core.SetReportPrintSettingsResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SignReportReq
 */
export const SignReportReq = proto3.makeMessageType(
  "com.diagnocat.core.SignReportReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SignReportResp
 */
export const SignReportResp = proto3.makeMessageType(
  "com.diagnocat.core.SignReportResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.UnsignReportReq
 */
export const UnsignReportReq = proto3.makeMessageType(
  "com.diagnocat.core.UnsignReportReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.UnsignReportResp
 */
export const UnsignReportResp = proto3.makeMessageType(
  "com.diagnocat.core.UnsignReportResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportMedicalImageViewOptionsReq
 */
export const SetReportMedicalImageViewOptionsReq = proto3.makeMessageType(
  "com.diagnocat.core.SetReportMedicalImageViewOptionsReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "MedicalImageViewOptions", kind: "message", T: MedicalImageViewOptions_Legacy },
    { no: 3, name: "MedicalImageViewOptions_V2", kind: "message", T: MedicalImageViewOptions },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportMedicalImageViewOptionsResp
 */
export const SetReportMedicalImageViewOptionsResp = proto3.makeMessageType(
  "com.diagnocat.core.SetReportMedicalImageViewOptionsResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetImageMetaViewOptionsReq
 */
export const SetImageMetaViewOptionsReq = proto3.makeMessageType(
  "com.diagnocat.core.SetImageMetaViewOptionsReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ImageMetaID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "MedicalImageViewOptions", kind: "message", T: MedicalImageViewOptions_Legacy },
    { no: 4, name: "MedicalImageViewOptions_V2", kind: "message", T: MedicalImageViewOptions },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetImageMetaViewOptionsResp
 */
export const SetImageMetaViewOptionsResp = proto3.makeMessageType(
  "com.diagnocat.core.SetImageMetaViewOptionsResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetImageMetaOrientationAngleReq
 */
export const SetImageMetaOrientationAngleReq = proto3.makeMessageType(
  "com.diagnocat.core.SetImageMetaOrientationAngleReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ImageMetaID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "OrientationAngle", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetImageMetaOrientationAngleResp
 */
export const SetImageMetaOrientationAngleResp = proto3.makeMessageType(
  "com.diagnocat.core.SetImageMetaOrientationAngleResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.PrintReportReq
 */
export const PrintReportReq = proto3.makeMessageType(
  "com.diagnocat.core.PrintReportReq",
  () => [
    { no: 1, name: "SurgicalGuide", kind: "message", T: PrintReportReq_ImplantologySurgicalGuide, oneof: "Input" },
    { no: 2, name: "GP", kind: "message", T: PrintReportReq_GP_Report, oneof: "Input" },
    { no: 100, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 101, name: "TimeZone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 102, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.PrintReportReq.ImplantologySurgicalGuide
 */
export const PrintReportReq_ImplantologySurgicalGuide = proto3.makeMessageType(
  "com.diagnocat.core.PrintReportReq.ImplantologySurgicalGuide",
  [],
  {localName: "PrintReportReq_ImplantologySurgicalGuide"},
);

/**
 * @generated from message com.diagnocat.core.PrintReportReq.GP_Report
 */
export const PrintReportReq_GP_Report = proto3.makeMessageType(
  "com.diagnocat.core.PrintReportReq.GP_Report",
  [],
  {localName: "PrintReportReq_GP_Report"},
);

/**
 * @generated from message com.diagnocat.core.PrintReportResp
 */
export const PrintReportResp = proto3.makeMessageType(
  "com.diagnocat.core.PrintReportResp",
  () => [
    { no: 1, name: "Document", kind: "message", T: Asset },
  ],
);

/**
 * //////////////////////////////////////////////////////////////
 * //////// @exclude TOOTH
 * //////////////////////////////////////////////////////////////
 *
 * @generated from message com.diagnocat.core.SetReportToothCommentReq
 */
export const SetReportToothCommentReq = proto3.makeMessageType(
  "com.diagnocat.core.SetReportToothCommentReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportToothCommentResp
 */
export const SetReportToothCommentResp = proto3.makeMessageType(
  "com.diagnocat.core.SetReportToothCommentResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.GenerateSuggestedToothTreatmentReq
 */
export const GenerateSuggestedToothTreatmentReq = proto3.makeMessageType(
  "com.diagnocat.core.GenerateSuggestedToothTreatmentReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.GenerateSuggestedToothTreatmentResp
 */
export const GenerateSuggestedToothTreatmentResp = proto3.makeMessageType(
  "com.diagnocat.core.GenerateSuggestedToothTreatmentResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothNumerationAndReviveReq
 */
export const SetToothNumerationAndReviveReq = proto3.makeMessageType(
  "com.diagnocat.core.SetToothNumerationAndReviveReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Numeration", kind: "message", T: ToothNumeration },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothNumerationAndReviveResp
 */
export const SetToothNumerationAndReviveResp = proto3.makeMessageType(
  "com.diagnocat.core.SetToothNumerationAndReviveResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothDetectionNumerationAndReviveReq
 */
export const SetToothDetectionNumerationAndReviveReq = proto3.makeMessageType(
  "com.diagnocat.core.SetToothDetectionNumerationAndReviveReq",
  () => [
    { no: 1, name: "ToothDetectionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Numeration", kind: "message", T: ToothNumeration },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothDetectionNumerationAndReviveResp
 */
export const SetToothDetectionNumerationAndReviveResp = proto3.makeMessageType(
  "com.diagnocat.core.SetToothDetectionNumerationAndReviveResp",
  () => [
    { no: 1, name: "Teeth", kind: "message", T: Tooth, repeated: true },
    { no: 2, name: "Conditions", kind: "message", T: Condition, repeated: true },
    { no: 3, name: "TeethLandmarks", kind: "message", T: ToothLandmark, repeated: true },
    { no: 4, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.MarkToothAsDeletedReq
 */
export const MarkToothAsDeletedReq = proto3.makeMessageType(
  "com.diagnocat.core.MarkToothAsDeletedReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.MarkToothAsDeletedResp
 */
export const MarkToothAsDeletedResp = proto3.makeMessageType(
  "com.diagnocat.core.MarkToothAsDeletedResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.MarkToothDetectionAsDeletedReq
 */
export const MarkToothDetectionAsDeletedReq = proto3.makeMessageType(
  "com.diagnocat.core.MarkToothDetectionAsDeletedReq",
  () => [
    { no: 1, name: "ToothDetectionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.MarkToothDetectionAsDeletedResp
 */
export const MarkToothDetectionAsDeletedResp = proto3.makeMessageType(
  "com.diagnocat.core.MarkToothDetectionAsDeletedResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.UpdateTeethStateReq
 */
export const UpdateTeethStateReq = proto3.makeMessageType(
  "com.diagnocat.core.UpdateTeethStateReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Updates", kind: "message", T: UpdateTeethStateReq_ToothUpdate, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.UpdateTeethStateReq.ToothUpdate
 */
export const UpdateTeethStateReq_ToothUpdate = proto3.makeMessageType(
  "com.diagnocat.core.UpdateTeethStateReq.ToothUpdate",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Target" },
    { no: 2, name: "ToothDetectionID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Target" },
    { no: 3, name: "SetNumeration", kind: "message", T: ToothNumeration, oneof: "Action" },
    { no: 4, name: "MarkDeleted", kind: "message", T: Empty, oneof: "Action" },
  ],
  {localName: "UpdateTeethStateReq_ToothUpdate"},
);

/**
 * @generated from message com.diagnocat.core.UpdateTeethStateResp
 */
export const UpdateTeethStateResp = proto3.makeMessageType(
  "com.diagnocat.core.UpdateTeethStateResp",
  () => [
    { no: 1, name: "Teeth", kind: "message", T: Tooth, repeated: true },
    { no: 2, name: "Conditions", kind: "message", T: Condition, repeated: true },
    { no: 3, name: "TeethLandmarks", kind: "message", T: ToothLandmark, repeated: true },
    { no: 4, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.ApproveReportToothReq
 */
export const ApproveReportToothReq = proto3.makeMessageType(
  "com.diagnocat.core.ApproveReportToothReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ToothConditionIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.ApproveReportToothResp
 */
export const ApproveReportToothResp = proto3.makeMessageType(
  "com.diagnocat.core.ApproveReportToothResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Conditions", kind: "message", T: Condition, repeated: true },
    { no: 3, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.DisapproveReportToothReq
 */
export const DisapproveReportToothReq = proto3.makeMessageType(
  "com.diagnocat.core.DisapproveReportToothReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.DisapproveReportToothResp
 */
export const DisapproveReportToothResp = proto3.makeMessageType(
  "com.diagnocat.core.DisapproveReportToothResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.ApproveAllTeethAndSignReportReq
 */
export const ApproveAllTeethAndSignReportReq = proto3.makeMessageType(
  "com.diagnocat.core.ApproveAllTeethAndSignReportReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "TeethConditionIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.ApproveAllTeethAndSignReportResp
 */
export const ApproveAllTeethAndSignReportResp = proto3.makeMessageType(
  "com.diagnocat.core.ApproveAllTeethAndSignReportResp",
  () => [
    { no: 1, name: "Report", kind: "message", T: Report },
    { no: 2, name: "Teeth", kind: "message", T: Tooth, repeated: true },
    { no: 3, name: "Conditions", kind: "message", T: Condition, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.ResetReportToothReq
 */
export const ResetReportToothReq = proto3.makeMessageType(
  "com.diagnocat.core.ResetReportToothReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.ResetReportToothResp
 */
export const ResetReportToothResp = proto3.makeMessageType(
  "com.diagnocat.core.ResetReportToothResp",
  () => [
    { no: 1, name: "Teeth", kind: "message", T: Tooth, repeated: true },
    { no: 2, name: "Conditions", kind: "message", T: Condition, repeated: true },
    { no: 3, name: "ToothLandmarks", kind: "message", T: ToothLandmark, repeated: true },
    { no: 4, name: "Report", kind: "message", T: Report },
    { no: 10, name: "ToothFullHeadMPR", kind: "message", T: ToothFullHeadMPR },
  ],
);

/**
 * @generated from message com.diagnocat.core.AddToothDisplaySliceReq
 */
export const AddToothDisplaySliceReq = proto3.makeMessageType(
  "com.diagnocat.core.AddToothDisplaySliceReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "AssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.AddToothDisplaySliceResp
 */
export const AddToothDisplaySliceResp = proto3.makeMessageType(
  "com.diagnocat.core.AddToothDisplaySliceResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.RemoveToothDisplaySliceReq
 */
export const RemoveToothDisplaySliceReq = proto3.makeMessageType(
  "com.diagnocat.core.RemoveToothDisplaySliceReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "AssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.RemoveToothDisplaySliceResp
 */
export const RemoveToothDisplaySliceResp = proto3.makeMessageType(
  "com.diagnocat.core.RemoveToothDisplaySliceResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.RemoveAllToothDisplaySlicesReq
 */
export const RemoveAllToothDisplaySlicesReq = proto3.makeMessageType(
  "com.diagnocat.core.RemoveAllToothDisplaySlicesReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.RemoveAllToothDisplaySlicesResp
 */
export const RemoveAllToothDisplaySlicesResp = proto3.makeMessageType(
  "com.diagnocat.core.RemoveAllToothDisplaySlicesResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.RestoreToothDisplaySlicesReq
 */
export const RestoreToothDisplaySlicesReq = proto3.makeMessageType(
  "com.diagnocat.core.RestoreToothDisplaySlicesReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.RestoreToothDisplaySlicesResp
 */
export const RestoreToothDisplaySlicesResp = proto3.makeMessageType(
  "com.diagnocat.core.RestoreToothDisplaySlicesResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothMPRSliceOptionsReq
 */
export const SetToothMPRSliceOptionsReq = proto3.makeMessageType(
  "com.diagnocat.core.SetToothMPRSliceOptionsReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SetOptions", kind: "message", T: ToothMPRSliceOptions, oneof: "Action" },
    { no: 3, name: "RestoreDefaults", kind: "message", T: Empty, oneof: "Action" },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothMPRSliceOptionsResp
 */
export const SetToothMPRSliceOptionsResp = proto3.makeMessageType(
  "com.diagnocat.core.SetToothMPRSliceOptionsResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
    { no: 10, name: "ToothFullHeadMPR", kind: "message", T: ToothFullHeadMPR },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothFullHeadMPRSliceSelectionReq
 */
export const SetToothFullHeadMPRSliceSelectionReq = proto3.makeMessageType(
  "com.diagnocat.core.SetToothFullHeadMPRSliceSelectionReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "IsAdded", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "Geometry", kind: "message", T: ToothFullHeadMPRSliceGeometry },
    { no: 6, name: "Series", kind: "message", T: ToothFullHeadMPRSliceSeries, oneof: "Target" },
    { no: 7, name: "SliceID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Target" },
    { no: 8, name: "View", kind: "message", T: ToothFullHeadMPRSliceView, oneof: "Target" },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothFullHeadMPRSliceSelectionResp
 */
export const SetToothFullHeadMPRSliceSelectionResp = proto3.makeMessageType(
  "com.diagnocat.core.SetToothFullHeadMPRSliceSelectionResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
    { no: 10, name: "ToothFullHeadMPR", kind: "message", T: ToothFullHeadMPR },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothFullHeadMPRSliceAnnotationsReq
 */
export const SetToothFullHeadMPRSliceAnnotationsReq = proto3.makeMessageType(
  "com.diagnocat.core.SetToothFullHeadMPRSliceAnnotationsReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Annotations", kind: "message", T: Annotation, repeated: true },
    { no: 5, name: "Geometry", kind: "message", T: ToothFullHeadMPRSliceGeometry },
    { no: 6, name: "Series", kind: "message", T: ToothFullHeadMPRSliceSeries, oneof: "Target" },
    { no: 7, name: "SliceID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Target" },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothFullHeadMPRSliceAnnotationsResp
 */
export const SetToothFullHeadMPRSliceAnnotationsResp = proto3.makeMessageType(
  "com.diagnocat.core.SetToothFullHeadMPRSliceAnnotationsResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
    { no: 10, name: "ToothFullHeadMPR", kind: "message", T: ToothFullHeadMPR },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothFullHeadMPRSliceViewOptionsReq
 */
export const SetToothFullHeadMPRSliceViewOptionsReq = proto3.makeMessageType(
  "com.diagnocat.core.SetToothFullHeadMPRSliceViewOptionsReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ViewOptions", kind: "message", T: MedicalImageViewOptions },
    { no: 5, name: "Geometry", kind: "message", T: ToothFullHeadMPRSliceGeometry },
    { no: 6, name: "Series", kind: "message", T: ToothFullHeadMPRSliceSeries, oneof: "Target" },
    { no: 7, name: "SliceID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Target" },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothFullHeadMPRSliceViewOptionsResp
 */
export const SetToothFullHeadMPRSliceViewOptionsResp = proto3.makeMessageType(
  "com.diagnocat.core.SetToothFullHeadMPRSliceViewOptionsResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
    { no: 10, name: "ToothFullHeadMPR", kind: "message", T: ToothFullHeadMPR },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothFullHeadMPRSliceEditorStateReq
 */
export const SetToothFullHeadMPRSliceEditorStateReq = proto3.makeMessageType(
  "com.diagnocat.core.SetToothFullHeadMPRSliceEditorStateReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Geometry", kind: "message", T: ToothFullHeadMPRSliceGeometry },
    { no: 3, name: "EditorState", kind: "message", T: ToothFullHeadMPRSliceEditorState },
    { no: 4, name: "ViewOptions", kind: "message", T: MedicalImageViewOptions },
    { no: 5, name: "Annotations", kind: "message", T: Annotations },
    { no: 9, name: "SignatureRemovalConfirmed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "Series", kind: "message", T: ToothFullHeadMPRSliceSeries, oneof: "Target" },
    { no: 7, name: "SliceID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Target" },
    { no: 8, name: "View", kind: "message", T: ToothFullHeadMPRSliceView, oneof: "Target" },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetToothFullHeadMPRSliceEditorStateResp
 */
export const SetToothFullHeadMPRSliceEditorStateResp = proto3.makeMessageType(
  "com.diagnocat.core.SetToothFullHeadMPRSliceEditorStateResp",
  () => [
    { no: 1, name: "Tooth", kind: "message", T: Tooth },
    { no: 2, name: "Report", kind: "message", T: Report },
    { no: 3, name: "SliceID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "ToothFullHeadMPR", kind: "message", T: ToothFullHeadMPR },
  ],
);

/**
 * @generated from message com.diagnocat.core.CreateReportToothConditionsReq
 */
export const CreateReportToothConditionsReq = proto3.makeMessageType(
  "com.diagnocat.core.CreateReportToothConditionsReq",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Conditions", kind: "message", T: CreateReportToothConditionsReq_Condition, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.CreateReportToothConditionsReq.Condition
 */
export const CreateReportToothConditionsReq_Condition = proto3.makeMessageType(
  "com.diagnocat.core.CreateReportToothConditionsReq.Condition",
  () => [
    { no: 1, name: "Code", kind: "enum", T: proto3.getEnumType(ConditionCode) },
    { no: 2, name: "ParentConditionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "CreateReportToothConditionsReq_Condition"},
);

/**
 * Condition with UserDecision == PositiveDecision
 *
 * @generated from message com.diagnocat.core.CreateReportToothConditionsResp
 */
export const CreateReportToothConditionsResp = proto3.makeMessageType(
  "com.diagnocat.core.CreateReportToothConditionsResp",
  () => [
    { no: 1, name: "Conditions", kind: "message", T: Condition, repeated: true },
    { no: 2, name: "Tooth", kind: "message", T: Tooth },
    { no: 3, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportToothConditionsUserDecisionReq
 */
export const SetReportToothConditionsUserDecisionReq = proto3.makeMessageType(
  "com.diagnocat.core.SetReportToothConditionsUserDecisionReq",
  () => [
    { no: 1, name: "PositiveDecisionConditionIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "NegativeDecisionConditionIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportToothConditionsUserDecisionResp
 */
export const SetReportToothConditionsUserDecisionResp = proto3.makeMessageType(
  "com.diagnocat.core.SetReportToothConditionsUserDecisionResp",
  () => [
    { no: 1, name: "Conditions", kind: "message", T: Condition, repeated: true },
    { no: 2, name: "Tooth", kind: "message", T: Tooth },
    { no: 3, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportToothConditionUserScoreAndApproveToothReq
 */
export const SetReportToothConditionUserScoreAndApproveToothReq = proto3.makeMessageType(
  "com.diagnocat.core.SetReportToothConditionUserScoreAndApproveToothReq",
  () => [
    { no: 1, name: "ConditionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "UserScore", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportToothConditionUserScoreAndApproveToothResp
 */
export const SetReportToothConditionUserScoreAndApproveToothResp = proto3.makeMessageType(
  "com.diagnocat.core.SetReportToothConditionUserScoreAndApproveToothResp",
  () => [
    { no: 1, name: "Condition", kind: "message", T: Condition },
    { no: 2, name: "Tooth", kind: "message", T: Tooth },
    { no: 3, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * One existing localization of a report whose user mask is set or reset.
 *
 * @generated from message com.diagnocat.core.UserMaskTarget
 */
export const UserMaskTarget = proto3.makeMessageType(
  "com.diagnocat.core.UserMaskTarget",
  () => [
    { no: 1, name: "ToothAnatomy", kind: "message", T: UserMaskTarget_ToothAnatomyTarget, oneof: "Localization" },
    { no: 2, name: "Condition", kind: "message", T: UserMaskTarget_ConditionTarget, oneof: "Localization" },
    { no: 3, name: "MaxFaxAnatomyLocalizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Localization" },
  ],
);

/**
 * @generated from message com.diagnocat.core.UserMaskTarget.ToothAnatomyTarget
 */
export const UserMaskTarget_ToothAnatomyTarget = proto3.makeMessageType(
  "com.diagnocat.core.UserMaskTarget.ToothAnatomyTarget",
  () => [
    { no: 1, name: "ToothDetectionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "LocalizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "UserMaskTarget_ToothAnatomyTarget"},
);

/**
 * @generated from message com.diagnocat.core.UserMaskTarget.ConditionTarget
 */
export const UserMaskTarget_ConditionTarget = proto3.makeMessageType(
  "com.diagnocat.core.UserMaskTarget.ConditionTarget",
  () => [
    { no: 1, name: "ConditionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "LocalizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "UserMaskTarget_ConditionTarget"},
);

/**
 * @generated from message com.diagnocat.core.SetReportUserMasksReq
 */
export const SetReportUserMasksReq = proto3.makeMessageType(
  "com.diagnocat.core.SetReportUserMasksReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Masks", kind: "message", T: SetReportUserMasksReq_UserMask, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetReportUserMasksReq.UserMask
 */
export const SetReportUserMasksReq_UserMask = proto3.makeMessageType(
  "com.diagnocat.core.SetReportUserMasksReq.UserMask",
  () => [
    { no: 1, name: "Target", kind: "message", T: UserMaskTarget },
    { no: 2, name: "PolygonalMask", kind: "message", T: ClosedPolygon, repeated: true },
  ],
  {localName: "SetReportUserMasksReq_UserMask"},
);

/**
 * @generated from message com.diagnocat.core.SetReportUserMasksResp
 */
export const SetReportUserMasksResp = proto3.makeMessageType(
  "com.diagnocat.core.SetReportUserMasksResp",
  () => [
    { no: 1, name: "Teeth", kind: "message", T: Tooth, repeated: true },
    { no: 2, name: "Conditions", kind: "message", T: Condition, repeated: true },
    { no: 3, name: "Report", kind: "message", T: Report },
  ],
);

/**
 * @generated from message com.diagnocat.core.ResetReportUserMasksReq
 */
export const ResetReportUserMasksReq = proto3.makeMessageType(
  "com.diagnocat.core.ResetReportUserMasksReq",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Selected", kind: "message", T: ResetReportUserMasksReq_SelectedMasks, oneof: "Scope" },
    { no: 3, name: "All", kind: "message", T: Empty, oneof: "Scope" },
  ],
);

/**
 * @generated from message com.diagnocat.core.ResetReportUserMasksReq.SelectedMasks
 */
export const ResetReportUserMasksReq_SelectedMasks = proto3.makeMessageType(
  "com.diagnocat.core.ResetReportUserMasksReq.SelectedMasks",
  () => [
    { no: 1, name: "Targets", kind: "message", T: UserMaskTarget, repeated: true },
  ],
  {localName: "ResetReportUserMasksReq_SelectedMasks"},
);

/**
 * @generated from message com.diagnocat.core.ResetReportUserMasksResp
 */
export const ResetReportUserMasksResp = proto3.makeMessageType(
  "com.diagnocat.core.ResetReportUserMasksResp",
  () => [
    { no: 1, name: "Teeth", kind: "message", T: Tooth, repeated: true },
    { no: 2, name: "Conditions", kind: "message", T: Condition, repeated: true },
    { no: 3, name: "Report", kind: "message", T: Report },
  ],
);

